import React, { useState } from "react";
import styled, { css, createGlobalStyle } from "styled-components";
import { Button, Form } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 25px;
  padding-bottom: 25px;
  background-color: #f5f5f5;
`;

const RegisterForm = styled(Form)`
  width: 500px;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  background-color: white;

  @media (max-width: 768px) {
    width: 90%; // スマホでは画面に収まるサイズ
    padding: 20px;
  }
`;

const RegisterButton = styled(Button)`
  width: 48%;
  min-height: 52px;
  white-space: normal;
  word-break: keep-all;
  font-size: 1rem;
  font-weight: 700;
`;

const SpacedFormGroup = styled(Form.Group)`
  margin-bottom: 15px;
`;

const SpacedForm = css`
  width: 440px;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  height: 500px;
  resize: none;
  background-color: white;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const GlobalStyle = createGlobalStyle`
  .custom-form-control {
    ${SpacedForm}
  }
  .form-control {
    color: black;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
`;

const EditGoalRegister = () => {
  const location = useLocation();
  const goal = location.state.goal || {};

  const [eventDetails, setEventDetails] = useState({
    無謀な夢: goal.title || "",
    目標実現日: goal.deadline || "",
    無謀な夢の詳細: goal.description || "",
  });

  const handleInputChange = (e) => {
    setEventDetails({
      ...eventDetails,
      [e.target.name]: e.target.value,
    });
  };

  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/DeleteGoal", { state: { goalId: goal.id } });
  };

  return (
    <React.StrictMode>
      <GlobalStyle />
      <Container>
        <RegisterForm>
          <SpacedFormGroup controlId="formBasicEvent">
            <Form.Label>無謀な夢</Form.Label>
            <Form.Control readOnly defaultValue={eventDetails.無謀な夢} name="無謀な夢" maxLength="20" type="text" placeholder="無謀な夢" onChange={handleInputChange} />
          </SpacedFormGroup>

          <SpacedFormGroup controlId="formBasicEventEndDate">
            <Form.Label>目標実現日</Form.Label>
            <Form.Control readOnly name="目標実現日" type="date" placeholder="目標実現日" value={eventDetails.目標実現日} onChange={handleInputChange} />
          </SpacedFormGroup>

          <SpacedFormGroup controlId="formBasicEventDetails">
            <Form.Label>無謀な夢の詳細</Form.Label>
            <Form.Control readOnly name="無謀な夢の詳細" as="textarea" type="text" placeholder="無謀な夢の詳細" className="custom-form-control" value={eventDetails.無謀な夢の詳細} onChange={handleInputChange} />
          </SpacedFormGroup>

          <ButtonContainer>
            <RegisterButton variant="contained" size="lg" block onClick={() => navigate(-1)} className="w-90 text-center d-flex align-items-center justify-content-center" style={{ minWidth: "120px", whiteSpace: "normal", lineHeight: 1.35, fontSize: "1rem", backgroundColor: "#282c34", color: "#ffffff", borderColor: "#282c34" }}>
              戻る
            </RegisterButton>
            <RegisterButton variant="danger" size="lg" onClick={handleClick} block className="w-90 text-center d-flex align-items-center justify-content-center" style={{ minWidth: "120px", whiteSpace: "normal", lineHeight: 1.35, fontSize: "1rem", backgroundColor: "#282c34", color: "#ffffff", borderColor: "#282c34" }}>
              削除する
            </RegisterButton>
          </ButtonContainer>
        </RegisterForm>
      </Container>
    </React.StrictMode>
  );
};

export default EditGoalRegister;
